// eslint-disable-next-line import/no-cycle
import store from '@client/store';
import {Route, NavigationGuardNext} from 'vue-router';

const startLoading = (_to: Route, _from: Route, next: NavigationGuardNext): void => {
  store.dispatch('setLoading', true);
  next();
};

export default startLoading;
